// Accessibility Enhancements
document.addEventListener("DOMContentLoaded", function () {
  /* ---------------------------
   * 1) External links: target/_blank + aria-label warning + optional img alt
   * --------------------------- */
(function handleExternalLinks() {
  const links = document.querySelectorAll("a");

  const excludedStartsWith = [
    "https://www.tiktok.com/",
    "https://hvb.holisticvetblend.com/",
  ];

  const warningText =
    "Redirecting to a third-party website (opens in a new tab)";

  const normalize = (url) => {
    try {
      return new URL(url, window.location.href).href;
    } catch (e) {
      return "";
    }
  };

  const isExcluded = (href) => {
    const full = normalize(href);
    if (!full) return false;
    return excludedStartsWith.some((prefix) => full.startsWith(prefix));
  };

  const isThirdParty = (href) => {
    try {
      const linkHost = new URL(href, window.location.href).hostname;
      const currentHost = window.location.hostname;
      return linkHost && linkHost !== currentHost;
    } catch (e) {
      return false;
    }
  };

  const hasWarning = (label) =>
    typeof label === "string" &&
    label.toLowerCase().includes("redirecting to a third-party website");

  links.forEach((link) => {
    const href = link.getAttribute("href");
    if (!href) return;

    if (!isThirdParty(href) || isExcluded(href)) return;

    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer");

    const img = link.querySelector("img");
    let imageAlt = "";

    // 🔹 If image is wrapped in link → move alt to aria-label
    if (img) {
      const altText = img.getAttribute("alt");

      if (altText && altText.trim() !== "") {
        imageAlt = altText.trim();

        // Remove alt from image (avoid duplicate announcement)
        img.setAttribute("alt", "");
      }
    }

    const existingAria = link.getAttribute("aria-label");
    const linkText = link.textContent.trim();

    let baseLabel = "";

    if (existingAria && existingAria.trim() !== "") {
      baseLabel = existingAria.trim();
    } else if (imageAlt) {
      baseLabel = imageAlt;
    } else if (linkText) {
      baseLabel = linkText;
    } else {
      baseLabel = "External link";
    }

    if (!hasWarning(baseLabel)) {
      link.setAttribute("aria-label", `${baseLabel}, ${warningText}`);
    }
  });
})();

  /* ---------------------------
   * 2) Email/tel links: aria-label
   * --------------------------- */
  (function handleContactLinks() {
    const links = document.querySelectorAll('a[href^="mailto:"], a[href^="tel:"]');

    links.forEach((link) => {
      const href = link.getAttribute("href") || "";
      const linkText = (link.textContent || "").trim();

      if (href.startsWith("mailto:")) {
        link.setAttribute("aria-label", `Email Address: ${linkText}`);
      } else if (href.startsWith("tel:")) {
        link.setAttribute("aria-label", `Phone number: ${linkText}`);
      }
    });
  })();

  /* ---------------------------
   * 3) Basic fixes
   * --------------------------- */
  (function basicFixes() {
    document.querySelectorAll("hr, br").forEach((el) => {
      el.setAttribute("aria-hidden", "true");
    });

    document.querySelectorAll(".swiper-wrapper").forEach((wrapper) => {
      wrapper.setAttribute("role", "list");
    });

    document
      .querySelectorAll("ul.dropdown-menu.dropdown-menu--standard li a.dropdown-submenu__link")
      .forEach((link) => {
        link.removeAttribute("aria-expanded");
      });
  })();

  /* ---------------------------
   * 4) Regular price SR text
   * --------------------------- */
  (function fixRegularPriceSrText() {
    const srText = document.querySelector("#price-field .money .sr-only");
    if (srText && srText.textContent.trim() === "Your Cart Subtotal") {
      srText.textContent = "Regular Price";
    }
  })();

  /* ---------------------------
   * 5) Internal links should not open in new tab
   * --------------------------- */
  (function removeTargetBlankForInternalLinks() {
    const links = document.querySelectorAll('a[target="_blank"]');
    const currentHost = window.location.hostname;

    links.forEach((link) => {
      try {
        const url = new URL(link.href, window.location.origin);
        if (url.hostname === currentHost) {
          link.removeAttribute("target");
        }
      } catch (e) {
        // ignore invalid URLs
      }
    });
  })();

  /* ---------------------------
   * 6) Heading structure: force h1 inside specific containers
   * --------------------------- */
  function replaceHeadingWithH1(containerSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    const heading = container.querySelector("h1, h2, h3, h4, h5, h6");
    if (!heading) return;

    if (heading.tagName.toLowerCase() === "h1") return;

    const newHeading = document.createElement("h1");
    newHeading.innerHTML = heading.innerHTML;

    for (let attr of heading.attributes) {
      newHeading.setAttribute(attr.name, attr.value);
    }

    heading.replaceWith(newHeading);
  }

  replaceHeadingWithH1(".title-bar.custom-font");
  replaceHeadingWithH1(".title-bar.wrapper--page-title");

  /* ---------------------------
   * 7) Search bar: clear button → focus back button
   * --------------------------- */
  (function searchBarAccessibility() {
    const clearBtn = document.getElementById("search-bar--clear");
    const backBtn = document.getElementById("backsearchbtn");
    if (!clearBtn || !backBtn) return;

    const observer = new MutationObserver(function () {
      if (document.body.contains(backBtn)) {
        backBtn.focus();
      }
    });

    clearBtn.addEventListener("click", function () {
      observer.observe(document.body, { childList: true, subtree: true });

      setTimeout(function () {
        backBtn.focus();
        observer.disconnect();
      }, 100);
    });
  })();

  /* ---------------------------
   * 8) Menu dropdown accessibility (mega-menu)
   * --------------------------- */
  (function megaMenuDropdownAccessibility() {
    const wrappers = Array.from(document.querySelectorAll(".mega-menu--dropdown-wrapper"));
    if (!wrappers.length) return;

    wrappers.forEach((wrapper) => {
      const menu = wrapper.querySelector(".dropdown-menu");
      const toggle = wrapper.querySelector(".dropdown-envy-toggle");

      wrapper.classList.remove("is-selected");
      if (menu) menu.style.display = "none";
      if (toggle) toggle.setAttribute("aria-expanded", "false");
    });

    function closeAll(exceptWrapper) {
      wrappers.forEach((w) => {
        if (exceptWrapper && w === exceptWrapper) return;

        const menu = w.querySelector(".dropdown-menu");
        const toggle = w.querySelector(".dropdown-envy-toggle");

        w.classList.remove("is-selected");
        if (menu) menu.style.display = "none";
        if (toggle) toggle.setAttribute("aria-expanded", "false");
      });
    }

    function toggleMenu(toggleEl) {
      const wrapper = toggleEl.closest(".mega-menu--dropdown-wrapper");
      if (!wrapper) return;

      const menu = wrapper.querySelector(".dropdown-menu");
      const isOpen = wrapper.classList.contains("is-selected");

      closeAll(wrapper);

      if (isOpen) {
        wrapper.classList.remove("is-selected");
        if (menu) menu.style.display = "none";
        toggleEl.setAttribute("aria-expanded", "false");
      } else {
        wrapper.classList.add("is-selected");
        if (menu) menu.style.display = "block";
        toggleEl.setAttribute("aria-expanded", "true");
      }
    }

    wrappers.forEach((wrapper) => {
      const toggle = wrapper.querySelector(".dropdown-envy-toggle");
      if (!toggle) return;

      toggle.addEventListener("click", function (e) {
        if (e.detail === 0) return; // ignore screen reader virtual clicks
        e.preventDefault();
        e.stopPropagation();
        toggleMenu(toggle);
      });

      toggle.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          e.stopPropagation();
          toggleMenu(toggle);
        }
      });
    });

    document.addEventListener("click", function () {
      closeAll();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        const focusedToggle =
          document.activeElement && document.activeElement.closest
            ? document.activeElement
                .closest(".mega-menu--dropdown-wrapper")
                ?.querySelector(".dropdown-envy-toggle")
            : null;

        const openWrapper = wrappers.find((w) => w.classList.contains("is-selected"));

        closeAll();

        if (focusedToggle) {
          focusedToggle.focus();
        } else if (openWrapper) {
          const t = openWrapper.querySelector(".dropdown-envy-toggle");
          if (t) t.focus();
        }
      }
    });
  })();


  /* ---------------------------
   * 10) Escape key: close open collection filters (details.js-filter[open])
   * --------------------------- */
  (function escapeClosesFilters() {
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;

      const openFilters = document.querySelectorAll("details.js-filter[open]");
      openFilters.forEach(function (filter) {
        filter.removeAttribute("open");

        const summary = filter.querySelector("summary");
        if (summary) {
          summary.setAttribute("aria-expanded", "false");
          summary.focus();
        }
      });
    });
  })();

  /* ---------------------------
   * 11) Convert h1 → h2 inside .accordion-container
   * --------------------------- */
  (function accordionH1toH2() {
    const headers = document.querySelectorAll(".accordion-container h1");
    headers.forEach((h1) => {
      const h2 = document.createElement("h2");
      h2.innerHTML = h1.innerHTML;

      h2.className = h1.className;
      Array.from(h1.attributes).forEach((attr) => {
        if (attr.name !== "class") h2.setAttribute(attr.name, attr.value);
      });

      h1.parentNode.replaceChild(h2, h1);
    });
  })();

  /* ---------------------------
   * 12) Home page slider: aria-hidden + tabindex management
   * --------------------------- */
  (function sliderAriaHiddenTabindex() {
    function updateAriaHidden() {
      document.querySelectorAll(".swiper-slide").forEach(function (slide) {
        slide.setAttribute("aria-hidden", "true");
        slide.querySelectorAll("a, button").forEach(function (el) {
          el.setAttribute("tabindex", "-1");
        });
      });

      document
        .querySelectorAll(".swiper-slide-active, .swiper-slide-next")
        .forEach(function (slide) {
          slide.setAttribute("aria-hidden", "false");
          slide.querySelectorAll("a, button").forEach(function (el) {
            el.removeAttribute("tabindex");
          });
        });
    }

    updateAriaHidden();

    document.querySelectorAll(".swiper-container").forEach(function (container) {
      container.addEventListener("transitionend", updateAriaHidden);
      container.addEventListener("webkitTransitionEnd", updateAriaHidden);
    });
  })();

  /* ---------------------------
   * 13) Escape key: close search wrapper and focus back button
   * --------------------------- */
  (function escapeClosesSearch() {
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;

      var searchWrapper = document.getElementById("top-search-wrapper");
      var searchBtn = document.getElementById("backsearchbtn");

      if (searchWrapper && searchBtn && searchWrapper.classList.contains("expanded")) {
        searchWrapper.classList.remove("expanded");
        searchBtn.setAttribute("aria-expanded", "false");
        searchBtn.focus();
      }
    });
  })();

  /* ---------------------------
   * 14) Search popup dialog fix (article→div, h5→h2) using MutationObserver
   * --------------------------- */
  (function searchPopupDialogFix() {
    if (!window.jQuery) return;
    const $ = window.jQuery;

    const targetNode = document.querySelector(".search-results-panel");
    if (!targetNode) return;

    const observer = new MutationObserver(function (mutationsList) {
      mutationsList.forEach(function (mutation) {
        if (!mutation.addedNodes || !mutation.addedNodes.length) return;

        $(".search-results-panel article").each(function () {
          if (!$(this).hasClass("converted")) {
            var content = $(this).html();
            $(this).replaceWith('<div class="search-result-item converted">' + content + "</div>");
          }
        });

        $(".search-results-panel h5").each(function () {
          if (!$(this).hasClass("converted-title")) {
            var content = $(this).html();
            $(this).replaceWith(
              '<h2 class="search-result-title converted-title">' + content + "</h2>"
            );
          }
        });
      });
    });

    observer.observe(targetNode, { childList: true, subtree: true });
  })();

  /* ---------------------------
   * 15) jQuery blocks (kept inside same DOMContentLoaded)
   * --------------------------- */
  (function jqueryEnhancements() {
    if (!window.jQuery) return;
    const $ = window.jQuery;

    // Mobile menu submenu focus manage
    (function mobileMenuSubFocus() {
      function disableSubmenu($submenu) {
        $submenu.attr("aria-hidden", "true");
        $submenu.find("a, button").attr("tabindex", "-1");
      }

      function enableSubmenu($submenu) {
        $submenu.attr("aria-hidden", "false");
        $submenu.find("a, button").removeAttr("tabindex");
      }

      $(".mobile-menu-sub").on("click", function () {
        var $parentLi = $(this).closest(".mobile-menu-link__has-submenu");
        var $submenu = $parentLi.find(".mobile-menu-child");

        setTimeout(function () {
          if ($submenu.hasClass("active")) {
            enableSubmenu($submenu);
            $submenu.find(".mobile-menu-back").focus();
          }
        }, 100);
      });

      $(".mobile-menu-back").on("click", function () {
        var $submenu = $(this).closest(".mobile-menu-child");
        var $parentLi = $(this).closest(".mobile-menu-link__has-submenu");
        var $triggerBtn = $parentLi.find(".mobile-menu-sub");

        setTimeout(function () {
          if (!$submenu.hasClass("active")) {
            disableSubmenu($submenu);
            $triggerBtn.focus();
          }
        }, 100);
      });
    })();

    // Mobile menu open/close focus manage
    (function mobileMenuOpenCloseFocus() {
      var $openBtn = $(".slide-menu-mobile");
      var $closeBtn = $(".menu-close-icon");

      $openBtn.on("click", function () {
        setTimeout(function () {
          $closeBtn.focus();
        }, 150);
      });

      $closeBtn.on("click", function () {
        setTimeout(function () {
          $openBtn.focus();
        }, 150);
      });
    })();

    // Add to cart drawer focus management
    (function cartDrawerFocus() {
      var lastFocusedButton = null;

      $(document).on("click", "#purchase", function () {
        lastFocusedButton = $(this);
      });

      var drawer = document.getElementById("cartSlideoutWrapper");
      if (drawer) {
        var observer = new MutationObserver(function () {
          if ($(drawer).hasClass("open") || $(drawer).is(":visible")) {
            setTimeout(function () {
              var $closeBtn = $(".cart-close-icon-wrapper .cart-menu-close").first();
              if ($closeBtn.length) $closeBtn.focus();
            }, 500);
          }
        });

        observer.observe(drawer, { attributes: true, attributeFilter: ["class"] });
      }

      $(document).on("click", ".cart-close-icon-wrapper .cart-menu-close", function () {
        setTimeout(function () {
          if (lastFocusedButton) lastFocusedButton.focus();
        }, 300);
      });
    })();

    // Table sequence correct
    (function prosemirrorTableHeaderFix() {
      $(".ProsemirrorEditor-table").each(function () {
        var $table = $(this);
        var $firstRow = $table.find("tr:first");

        $firstRow.find("td").each(function () {
          $(this).replaceWith('<th scope="col">' + $(this).html() + "</th>");
        });

        if ($table.find("thead").length === 0) {
          $firstRow.wrapAll("<thead></thead>");
        }
      });
    })();

    // Remove empty headings + observe DOM
    (function removeEmptyHeadings() {
      function run() {
        $("h1, h2, h3, h4, h5, h6").each(function () {
          var $heading = $(this);
          var clone = $heading.clone();

          clone.find("br").remove();
          clone.find("span").each(function () {
            if ($.trim($(this).text()) === "") $(this).remove();
          });

          if ($.trim(clone.text()) === "") $heading.remove();
        });
      }

      run();

      var observer = new MutationObserver(function () {
        run();
      });

      observer.observe(document.body, { childList: true, subtree: true });
    })();

    // aria-modal remove (and re-remove if re-added)
    (function ariaModalRemove() {
      function removeAriaModal() {
        $("#cartSlideoutWrapper, #top-search-wrapper").each(function () {
          if ($(this).attr("aria-modal")) $(this).removeAttr("aria-modal");
        });
      }

      removeAriaModal();

      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === "attributes" && mutation.attributeName === "aria-modal") {
            removeAriaModal();
          }
        });
      });

      document.querySelectorAll("#cartSlideoutWrapper, #top-search-wrapper").forEach(function (t) {
        observer.observe(t, { attributes: true });
      });
    })();
  })();
});

document.addEventListener("DOMContentLoaded", function () {
  const body = document.body;
  // Run only on Home OR Cart page
  if (
    !body.classList.contains("template-index") &&
    !body.classList.contains("template-cart") &&
    !body.classList.contains("template-article")
  ) return;

  const headings = document.querySelectorAll(".title-bar.custom-font h1");

  headings.forEach(function (heading) {

    const newHeading = document.createElement("h2");

    // Copy inner content
    newHeading.innerHTML = heading.innerHTML;

    // Copy all attributes
    Array.from(heading.attributes).forEach(function (attr) {
      newHeading.setAttribute(attr.name, attr.value);
    });

    // Replace h1 with h2
    heading.parentNode.replaceChild(newHeading, heading);

  });

});

document.addEventListener("DOMContentLoaded", function () {

  function removeExpanded() {
    document
      .querySelectorAll("ul.dropdown-menu.dropdown-menu--standard li > a")
      .forEach(function (link) {
        link.removeAttribute("aria-expanded");
      });
  }

  // Mouse click on any anchor
  document.addEventListener("click", function (e) {
    const anchor = e.target.closest("a");
    if (!anchor) return;

    removeExpanded();
  });

  // Keyboard interaction (Enter / Space)
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Enter" && e.key !== " ") return;

    const anchor = e.target.closest("a");
    if (!anchor) return;

    removeExpanded();
  });

  // Focus interaction
  document.addEventListener("focusin", function (e) {
    const anchor = e.target.closest("a");
    if (!anchor) return;

    removeExpanded();
  });

});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(
    ".quill-better-table-wrapper .quill-better-table tbody tr td p"
  ).forEach(td => {
    td.removeAttribute("contenteditable");
  });
});